/**
 * Visual styling and behaviour for candidate openings (SVG∩frame-derived
 * "Add opening?" suggestions): the dashed outline on the canvas, the DOM
 * confirmation bubble's sizing/positioning, and its zoom thresholds.
 */
export const CandidateOpeningStyle = {
	// Dashed candidate outline on the canvas.
	strokeColor: 0x6b7280,
	strokeAlpha: 0.8,
	hoverStrokeAlpha: 1,
	strokeWidth: 1.5,
	hoverStrokeWidth: 2.25,
	dashLength: 4,
	gapLength: 3,

	// Confirmation bubble placement around the candidate (screen px; the bubble sizes itself).
	/** Gap between the candidate's screen bounds and the bubble edge. */
	bubbleAnchorGap: 12,
	/** Minimum clearance kept between the bubble and the canvas edges. */
	edgePadding: 8,

	/** Above this zoom the bubble is a constant on-screen size; at/below it locks to world size. */
	worldLockZoom: 0.5,
	/** Below this zoom the bubble is hidden entirely. */
	minVisibleZoom: 0.3,
} as const;
